import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./serialNumber_help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class ServiceRepairRelatedBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Service Repair Related</strong></h1>
            <p>
                This dispute type is used for service repair related: "Dead On Arrival", "Multiple Repaired Units" and "Not Repaired Within Legally Stated Period".
            </p>
            <p>
                For successful result, please follow the instructions:
            </p>
            <p>
                1. Choose the correct subtype from the drop down menu.
            </p>
            <p>
                2. Attach service protocol or appropriate refund confirmation.
            </p>
            <p>
                3. Make sure, that all the documentation refers to the claimed Serial Number/s.
            </p>
            <p>
                4. In case of partial refund put the requested % to the comments.
            </p>
            <p>
                5. For approved DOA cases by services team, distributor has 60 days MAX to claim its DOA credit back, if period expired, no refund will be executed.
            </p>
            <p className="underscore">
                In case service approval is missing, your claim will be rejected. Please revert to Lenovo service team in order to obtain confirmation of service approval. Once confirmed by services that your request is approved, you can reupload your claim.
            </p>
            <p className="color_word">
                In case of mass Service Repair Related request, please use the template to fill in required data and attach it.
            </p>
            <Help_hints />
        </div>
    }
}

export default ServiceRepairRelatedBar;